module.exports = __webpack_public_path__ + "static/media/why_daidish.37c0f896.webp";